import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import { useHistory } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";

// import "./TDSRecon.css";
import SelectField from "../../../../components/ui/basicSelectInput";

import BoxWrapper from "../../../../components/ui/boxWrapper";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function TDSReconciliation() {
  let history = useHistory();
  const [newReconFormOpen, setNewReconFormOpen] = useState(false);
  const [newReconFormData, setNewReconFormData] = useState({
    business_entity_id: localStorage.getItem("business_entity_id"),
  });
  const [newReconHistoryTable, setNewReconHistoryTable] = useState([]);
  const [yearFromArr, setFromYearArr] = useState([]);
  const [reportStatusModalOpen, setReportStatusModalOpen] = useState(false);
  const [showDetailsModalOpen, setShowDetailsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [email, setEmail] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [errorMessageForBoxWrapper, setErrorMessageForBoxWrapper] = useState("");
  const [closeBoxWrapper, setCloseBoxWrapper] = useState(false);
  const [loaderForTable, setLoaderForTable] = useState(true);
  const [reportStatusData, setReportStatusData] = useState([]);
  const [currentReconId, setCurrentReconId] = useState(null);
  const [reconData, setReconData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleBack = () => {
    history.push('/reconCards');
  };

  const getTdsReconDetails = () => {
    axios
      .get(
        `/gstr9_summary/${localStorage.getItem('business_entity_id')}/${localStorage.getItem('gst')}`
      )
      .then((res) => {
        setLoaderForTable(false);
        setNewReconHistoryTable(res.data.records);

        if (res.data.records && res.data.records.length > 0) {
          const firstRecord = res.data.records[0]; 
          localStorage.setItem('financial_year', firstRecord.financial_year);
          localStorage.setItem('id', firstRecord.id);
          console.log(localStorage.setItem('financial_year', firstRecord.financial_year));
          console.log(localStorage.setItem('id', firstRecord.id));
          
        }

        if (yearFromArr.length > 0) {
          setSelectedYear(yearFromArr[0].year);
        }
      })
      .catch((error) => {
        setLoaderForTable(false);
        setSnackbarMessage(error?.response?.data?.message || "An error occurred");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };

  const setFromYearValues = () => {
    const currentYear = new Date().getFullYear();
    const yearsList = Array.from({ length: 10 }, (_, index) => {
      const year = currentYear - index;
      return `${year}-${(year + 1).toString().slice(-2)}`;
    });
    let yearArr = yearsList.map((year, index) => ({
      id: index + 1,
      year,
      choice_id: year,
      choice_name: year,
    }));
    setFromYearArr(yearArr);
    console.log('yearArr..........', yearArr);
  };

  useEffect(() => {
    setFromYearValues();
    getTdsReconDetails();
  }, []);

  const newReconFormModalOpen = () => {
    setNewReconFormOpen(true);
  };

  const newReconYearChangeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    
    setNewReconFormData({
      ...newReconFormData,
      [name]: value,
    });
  };

  const newReconFormSubmitHandler = () => {
    axios
      .post("/gstr9_recon", { ...newReconFormData, 'gstin': localStorage.getItem('gst'), })
      .then((res) => {
        setNewReconFormOpen(false);
        setNewReconFormData({
          business_entity_id: localStorage.getItem("business_entity_id"),
        });
        getTdsReconDetails();
        if (res?.data?.status) {
          // setSnackbarMessage(res?.data?.msg);
          // setSnackbarSeverity("success");
          // setSnackbarOpen(true);
        } else {
          setSnackbarMessage(res?.data?.msg);
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.errors || "An error occurred");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };

  const newReconFormModalClose = () => {
    setNewReconFormOpen(false);
    setNewReconFormData({
      business_entity_id: localStorage.getItem("business_entity_id"),
    });
  };



    const updatedShowDetails = (item) => {
      localStorage.setItem("gstr9_financail_year", `${item.financial_year}`);
      localStorage.setItem("gstr9_recon_id", `${item.id}`);
      setSelectedItem(item);
      setCurrentReconId(item.id);
      setShowDetailsModalOpen(true);
      axios
        .get(`/get_gstr9c_summay_details/${item.id}`)
        .then((res) => {
          setErrorMessageForBoxWrapper(res?.data?.records?.message);
          setCloseBoxWrapper(true);
          setReconData(res?.data?.records || []);
          if (res?.data?.records && Array.isArray(res.data.records)) {
            const gstr9cReconIds = res.data.records
              .filter(record => record.gstr9c_recon_id !== undefined)
              .map(record => record.gstr9c_recon_id);
            localStorage.setItem("gstr9c_rean_ids", JSON.stringify(gstr9cReconIds));
          }
        })
        .catch((error) => {
          console.log(error);
      });
    };

  const historyTableBody = () => {
    const showErrorDetails = (item) => {
      axios
        .get(`/form_26/get_json/${item.id}`)
        .then((res) => {
          setErrorMessageForBoxWrapper(res?.data?.records?.message);
          setCloseBoxWrapper(true);
        })
        .catch((error) => {
          console.log(error);
        });
    };


    if (loaderForTable) {
      console.log("Loader");
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={4}
          >
            Loading…Please wait
          </td>
        </tr>
      );
    } else if (newReconHistoryTable && newReconHistoryTable.length > 0) {
      return newReconHistoryTable.map((item, index) => {
        const { financial_year, period, recon_run_date_time, recon_status, id } = item;
        return (
          <tr key={index}>
            <td>{financial_year}</td>
            <td>{period}</td>
            <td>{recon_run_date_time}</td>
            <td>{recon_status}</td>
            <td>
              {recon_status === "Pass" && (
                <VisibilityOutlinedIcon
                  className="action-icon-button showIcon"
                  onClick={() => updatedShowDetails(item)}
                />
              )}
              {recon_status === "Fail" && (
                <VisibilityOutlinedIcon
                  className="action-icon-button deleteIcon"
                  onClick={() => showErrorDetails(item)}
                />
              )}
              {recon_status === "Initiated" && (
                <VisibilityOutlinedIcon
                  className="action-icon-button deleteIcon"
                  color="disabled"
                />
              )}
            </td>
            <td><SettingsIcon className="action-icon-button showIcon" onClick={() => handleReportStatus(id)} /></td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={4}>
            No data found!
          </td>
        </tr>
      );
    }
  };

  const refreshUploadHistoryTable = () => {
    getTdsReconDetails();
  };

  const FunForcloseBoxWapper = () => {
    setCloseBoxWrapper(false);
  };

  const handleReportStatus = (id) => {
    console.log(id);
    setCurrentReconId(id);
    gstrfetchData(id);
    setReportStatusModalOpen(true);
  };

  const gstrfetchData = (id) => {
    axios
      .get(`/gstr9_others_logs/${id}`)
      .then((res) => {
        setReportStatusData(res?.data?.records);
        setErrorMessageForBoxWrapper(res?.data?.records?.message);
        setCloseBoxWrapper(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const closeReportStatusModal = () => {
    setReportStatusModalOpen(false);
  };

  const handleReportStatusRefresh = (id) => {
    gstrfetchData(id);
    console.log("Refreshing report status table...");
  };

  const closeShowDetailsModal = () => {
    setShowDetailsModalOpen(false);
    setSelectedItem(null);
    setEmail("");
  };

  const ModernNewsletterPopup = () => {
    return (
      <>
        {showDetailsModalOpen && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 182, 193, 0.2)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '1rem',
              zIndex: 1050
            }}
          >
            <div
              style={{
                backgroundColor: '#fefefe',
                borderRadius: '1.5rem',
                boxShadow: '0 20px 40px rgba(186, 230, 253, 0.3), 0 8px 16px rgba(165, 180, 252, 0.2)',
                width: '100%',
                maxWidth: 'min(90vw, 700px)',
                margin: '0 1rem',
                overflow: 'hidden',
                transform: 'scale(1) rotate(0.5deg)',
                transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
              }}
            >
              <div
                style={{
                  background: 'linear-gradient(135deg, #fae7f3 0%, #e0e7ff 50%, #f0f9ff 100%)',
                  padding: '1rem 1.5rem',
                  textAlign: 'left',
                  position: 'relative',
                  overflow: 'hidden',
                  borderBottom: '2px solid rgba(196, 181, 253, 0.3)'
                }}
              >
                <div style={{ position: 'absolute', top: '1.25rem', left: '1.25rem', width: '0.75rem', height: '0.75rem', backgroundColor: '#fbbf24', borderRadius: '50%', opacity: 0.7, animation: 'float 3s ease-in-out infinite' }}></div>
                <div style={{ position: 'absolute', top: '2.2rem', left: '3.75rem', width: '0.5rem', height: '0.5rem', backgroundColor: '#f87171', borderRadius: '50%', opacity: 0.6, animation: 'float 3s ease-in-out infinite', animationDelay: '1s' }}></div>
                <div style={{ position: 'absolute', top: '1.6rem', right: '2.5rem', width: '0.625rem', height: '0.625rem', backgroundColor: '#a78bfa', borderRadius: '50%', opacity: 0.8, animation: 'float 3s ease-in-out infinite', animationDelay: '2s' }}></div>
                <div style={{ position: 'absolute', bottom: '1.9rem', left: '2.5rem', width: '0.375rem', height: '0.375rem', backgroundColor: '#34d399', borderRadius: '50%', opacity: 0.7, animation: 'float 3s ease-in-out infinite', animationDelay: '1.5s' }}></div>
                <div style={{ position: 'absolute', bottom: '1.25rem', right: '1.9rem', width: '0.5rem', height: '0.5rem', backgroundColor: '#60a5fa', borderRadius: '50%', opacity: 0.6, animation: 'float 3s ease-in-out infinite', animationDelay: '0.5s' }}></div>

                <div style={{ position: 'absolute', top: '1.25rem', right: '1.25rem', color: '#f472b6', opacity: 0.8, animation: 'sparkle 2s ease-in-out infinite' }}>
                  <svg width="1rem" height="1rem" viewBox="0 0 16 16" fill="none">
                    <path d="M8 0L10 6L16 8L10 10L8 16L6 10L0 8L6 6L8 0Z" fill="currentColor" />
                  </svg>
                </div>
                <div style={{ position: 'absolute', bottom: '2.5rem', left: '1.25rem', color: '#a78bfa', opacity: 0.7, animation: 'sparkle 2s ease-in-out infinite', animationDelay: '1s' }}>
                  <svg width="0.75rem" height="0.75rem" viewBox="0 0 12 12" fill="none">
                    <path d="M6 0L7.5 4.5L12 6L7.5 7.5L6 12L4.5 7.5L0 6L4.5 4.5L6 0Z" fill="currentColor" />
                  </svg>
                </div>

                <div style={{ textAlign: 'left', marginLeft: '0.5rem' }}>
                  <h2 style={{
                    fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
                    fontWeight: '700',
                    color: '#374151',
                    marginBottom: '0.125rem',
                    letterSpacing: '-0.02em',
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}>
                    Tax Reconciliation
                  </h2>
                  <p style={{
                    color: '#6b7280',
                    fontSize: 'clamp(0.7rem, 1.5vw, 0.75rem)',
                    lineHeight: '1.3',
                    fontWeight: '400'
                  }}>
                    Choose your reconciliation type
                  </p>
                </div>

                <button
                  onClick={closeShowDetailsModal}
                  style={{
                    position: 'absolute',
                    top: '1.25rem',
                    right: '1.25rem',
                    color: '#f472b6',
                    background: 'rgba(255, 255, 255, 0.6)',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0.5rem',
                    borderRadius: '50%',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(10px)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(244, 114, 182, 0.2)';
                    e.target.style.transform = 'rotate(90deg)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                    e.target.style.transform = 'rotate(0deg)';
                  }}
                >
                  <svg width="1.25rem" height="1.25rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div style={{ padding: '1rem 1.5rem', backgroundColor: '#fefefe' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', maxWidth: 'min(85vw, 600px)' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #fef3c7 0%, #fce7f3 100%)',
                    padding: '0.75rem 1rem',
                    borderRadius: '0.75rem',
                    boxShadow: '0 4px 8px rgba(251, 191, 36, 0.15)',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden',
                    alignSelf: 'flex-end',
                    width: 'min(85%, 400px)',
                    transform: 'rotate(-1.10deg)',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '0.5rem',
                      right: '0.5rem',
                      width: '0.375rem',
                      height: '0.375rem',
                      backgroundColor: '#f59e0b',
                      borderRadius: '50%',
                      opacity: 0.7,
                      animation: 'pulse 2s infinite'
                    }}></div>
                    <h3 style={{
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                      fontWeight: '700',
                      color: '#92400e',
                      marginBottom: '0.25rem',
                      letterSpacing: '-0.02em'
                    }}>GSTR-9 Reconciliation</h3>
                    <p style={{
                      color: '#a16207',
                      fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                      marginBottom: '0.5rem',
                      lineHeight: '1.3'
                    }}>Annual return reconciliation</p>
                    <button
                      onClick={() => {
                        const selectedItem = { financial_year: selectedYear };
                        showRecon(selectedItem);
                      }}
                      style={{
                        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                        color: 'white',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        border: 'none',
                        fontWeight: '600',
                        fontSize: 'clamp(0.75rem, 1.5vw, 0.8rem)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 4px rgba(245, 158, 11, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px) scale(1.05)';
                        e.target.style.boxShadow = '0 6px 12px rgba(245, 158, 11, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0) scale(1)';
                        e.target.style.boxShadow = '0 2px 4px rgba(245, 158, 11, 0.3)';
                      }}
                    >
                      Begin Journey
                    </button>
                  </div>
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)',
                      padding: '0.75rem 1rem',
                      borderRadius: '0.75rem',
                      boxShadow: '0 4px 8px rgba(96, 165, 250, 0.15)',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      overflow: 'hidden',
                      alignSelf: 'flex-start',
                      width: 'min(85%, 400px)',
                      transform: 'rotate(1.10deg)',
                      textAlign: 'left',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '0.5rem',
                        left: '0.5rem',
                        width: '0.375rem',
                        height: '0.375rem',
                        backgroundColor: '#3b82f6',
                        borderRadius: '50%',
                        opacity: 0.7,
                        animation: 'pulse 2s infinite',
                      }}
                    ></div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.25rem',
                      }}
                    >
                      <h3
                        style={{
                          fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                          fontWeight: '700',
                          color: '#1e40af',
                          letterSpacing: '-0.02em',
                        }}
                      >
                        GSTR-9C Reconciliation
                      </h3>
                      <button
                        // onClick={() => window.location.reload()}
                        onClick={() => refreshgstr9c()}
                        style={{
                          background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                          color: 'white',
                          padding: '0.4rem 0.8rem',
                          borderRadius: '0.5rem',
                          border: 'none',
                          fontWeight: '600',
                          fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-2px) scale(1.05)';
                          e.target.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0) scale(1)';
                          e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
                        }}
                      >
                        Refresh
                      </button>
                    </div>
                    <p
                      style={{
                        color: '#1d4ed8',
                        fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                        marginBottom: '0.5rem',
                        lineHeight: '1.3',
                      }}
                    >
                      Certified annual return preparation
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                      }}
                    >
                      {reconData && Array.isArray(reconData) && reconData.length > 0 ? (
                        reconData.map((record, index) => {
                          const isDisabled = !record || record.recon_status !== 'Pass';
                          return (
                            <div
                              key={index}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '0.5rem',
                                borderBottom: index < reconData.length - 1 ? '1px solid #e5e7eb' : 'none',
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <p
                                  style={{
                                    color: '#1d4ed8',
                                    fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                                    margin: 0,
                                  }}
                                >
                                  <strong>Reconciliation Run Date:</strong> {record.recon_run_date_time || 'N/A'}
                                </p>
                                <p
                                  style={{
                                    color: '#1d4ed8',
                                    fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                                    margin: 0,
                                  }}
                                >
                                  <strong>Status:</strong> {record.recon_status || 'N/A'}
                                </p>
                              </div>
                              <button
                                onClick={() => show9cRecon(record.gstr9c_recon_id)}
                                disabled={isDisabled}
                                style={{
                                  background: isDisabled
                                    ? '#d1d5db'
                                    : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                                  color: isDisabled ? '#6b7280' : 'white',
                                  padding: '0.5rem 1rem',
                                  borderRadius: '0.5rem',
                                  border: 'none',
                                  fontWeight: '600',
                                  fontSize: 'clamp(0.75rem, 1.5vw, 0.8rem)',
                                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                                  transition: 'all 0.3s ease',
                                  boxShadow: isDisabled ? 'none' : '0 2px 4px rgba(59, 130, 246, 0.3)',
                                  minWidth: '120px',
                                }}
                                onMouseEnter={(e) => {
                                  if (!isDisabled) {
                                    e.target.style.transform = 'translateY(-2px) scale(1.05)';
                                    e.target.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isDisabled) {
                                    e.target.style.transform = 'translateY(0) scale(1)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
                                  }
                                }}
                              >
                                Begin Journey
                              </button>
                            </div>
                          );
                        })
                      ) : (
                        <p
                          style={{
                            color: '#1d4ed8',
                            fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                            margin: 0,
                          }}
                        >
                          No reconciliation data available.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* <div
                    style={{
                      background: 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)',
                      padding: '0.75rem 1rem',
                      borderRadius: '0.75rem',
                      boxShadow: '0 4px 8px rgba(96, 165, 250, 0.15)',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      overflow: 'hidden',
                      alignSelf: 'flex-start',
                      width: 'min(85%, 400px)',
                      transform: 'rotate(1.10deg)',
                      textAlign: 'left',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: '0.5rem',
                        left: '0.5rem',
                        width: '0.375rem',
                        height: '0.375rem',
                        backgroundColor: '#3b82f6',
                        borderRadius: '50%',
                        opacity: 0.7,
                        animation: 'pulse 2s infinite',
                      }}
                    ></div>
                    <h3
                      style={{
                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                        fontWeight: '700',
                        color: '#1e40af',
                        marginBottom: '0.25rem',
                        letterSpacing: '-0.02em',
                      }}
                    >
                      GSTR-9C Reconciliation
                    </h3>
                    <p
                      style={{
                        color: '#1d4ed8',
                        fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                        marginBottom: '0.5rem',
                        lineHeight: '1.3',
                      }}
                    >
                      Certified annual return preparation
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                      }}
                    >
                      {reconData && Array.isArray(reconData) && reconData.length > 0 ? (
                        reconData.map((record, index) => {
                          const isDisabled = !record || record.recon_status !== 'Pass';
                          return (
                            <div
                              key={index}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '0.5rem',
                                borderBottom: index < reconData.length - 1 ? '1px solid #e5e7eb' : 'none',
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <p
                                  style={{
                                    color: '#1d4ed8',
                                    fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                                    margin: 0,
                                  }}
                                >
                                  <strong>Reconciliation Run Date:</strong> {record.recon_run_date_time || 'N/A'}
                                </p>
                                <p
                                  style={{
                                    color: '#1d4ed8',
                                    fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                                    margin: 0,
                                  }}
                                >
                                  <strong>Status:</strong> {record.recon_status || 'N/A'}
                                </p>
                              </div>
                              <button
                                onClick={() => show9cRecon(record.gstr9c_recon_id)}
                                disabled={isDisabled}
                                style={{
                                  background: isDisabled
                                    ? '#d1d5db'
                                    : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                                  color: isDisabled ? '#6b7280' : 'white',
                                  padding: '0.5rem 1rem',
                                  borderRadius: '0.5rem',
                                  border: 'none',
                                  fontWeight: '600',
                                  fontSize: 'clamp(0.75rem, 1.5vw, 0.8rem)',
                                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                                  transition: 'all 0.3s ease',
                                  boxShadow: isDisabled ? 'none' : '0 2px 4px rgba(59, 130, 246, 0.3)',
                                  minWidth: '120px',
                                }}
                                onMouseEnter={(e) => {
                                  if (!isDisabled) {
                                    e.target.style.transform = 'translateY(-2px) scale(1.05)';
                                    e.target.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isDisabled) {
                                    e.target.style.transform = 'translateY(0) scale(1)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
                                  }
                                }}
                              >
                                Begin Journey
                              </button>
                            </div>
                          );
                        })
                      ) : (
                        <p
                          style={{
                            color: '#1d4ed8',
                            fontSize: 'clamp(0.65rem, 1.2vw, 0.7rem)',
                            margin: 0,
                          }}
                        >
                          No reconciliation data available.
                        </p>
                      )}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}

        <style>
          {`
          @keyframes pulse {
            0%, 100% { 
              opacity: 1; 
              transform: scale(1);
            }
            50% { 
              opacity: 0.6; 
              transform: scale(1.1);
            }
          }
          
          @keyframes float {
            0%, 100% { 
              transform: translateY(0px) rotate(0deg); 
            }
            50% { 
              transform: translateY(-8px) rotate(180deg); 
            }
          }
          
          @keyframes sparkle {
            0%, 100% { 
              opacity: 1; 
              transform: scale(1) rotate(0deg);
            }
            50% { 
              opacity: 0.5; 
              transform: scale(1.2) rotate(90deg);
            }
          }
        `}
        </style>
      </>
    );
  };

  const showRecon = (item) => {
    localStorage.getItem("gstr9_financail_year", `${item.financial_year}`);
    localStorage.getItem("gstr9_recon_id", `${item.id}`);
    console.log(localStorage.getItem("gstr9_financail_year", `${item.financial_year}`));
    console.log(localStorage.getItem("gstr9_recon_id", `${item.id}`));
    history.push({
      pathname: `/GSTR9-ReportingPage/${localStorage.getItem("gstr9_recon_id", `${item.id}`)}`,
    });


    const actualRecord = newReconHistoryTable.find(record =>
      record.financial_year === item.financial_year
    );
    console.log('actualRecord:', actualRecord);

    // if (actualRecord) {
    //   setCurrentReconId(actualRecord.id);
    //   console.log('recon_id:', actualRecord.id);
    //   localStorage.setItem('gstr9_financial_year', actualRecord.financial_year); // Fixed typo
    //   history.push({
    //     pathname: `/GSTR9-ReportingPage/${actualRecord.id}`,
    //   });
    // } 
  };


  const refreshgstr9c = () => {
    const itemToRefresh = selectedItem || (newReconHistoryTable && newReconHistoryTable.length > 0 ? newReconHistoryTable[0] : null);
    if (itemToRefresh) {
     updatedShowDetails(itemToRefresh);
    } else {
      setSnackbarMessage('No item available to refresh');
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const show9cRecon = (gstr9cReconId) => {
    const actualRecord = newReconHistoryTable.find(record =>
      record.financial_year === (selectedItem?.financial_year || selectedYear)
    );

    if (actualRecord && gstr9cReconId) {
      setCurrentReconId(actualRecord.id);
      console.log('Navigating with recon_id:', actualRecord.id, 'and gstr9c_recon_id:', gstr9cReconId);
      localStorage.setItem('gstr9c_recon_id', `${gstr9cReconId}`);
      localStorage.setItem('gstr9_financial_year', `${actualRecord.financial_year}`);
      history.push({
        pathname: `/GSTR_9CReconciliationdata/${actualRecord.id}/${gstr9cReconId}`,
      });
    } else {
      setSnackbarMessage('Please select a valid financial year or reconciliation ID.');
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    getTdsReconDetails();
  }, []);

  return (
    <>
      <div className="new-reconciliation-form">
        <button
          className="button-outlined-primary"
          onClick={newReconFormModalOpen}
        >
          GSTR-9 Reconciliation
        </button>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBack}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>

        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={newReconFormOpen}
          onHide={newReconFormModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton className="modal-header">
            <Modal.Title className="modal-title">
              GSTR-9 Reconciliation
            </Modal.Title>
          </Modal.Header>

          <ValidatorForm
            onSubmit={newReconFormSubmitHandler}
          >
            <Modal.Body>
              <div className="new-recon-form-body">
                <Grid container spacing={2}>
                  <Grid item sm>
                    <SelectField
                      SelectLabel="financial_year"
                      validator={["required"]}
                      requiredField="*"
                      errorMsg={["This field is required"]}
                      choice_id="year"
                      choice_name="year"
                      choices={yearFromArr}
                      name="financial_year"
                      value={newReconFormData.financial_year}
                      textOnchangeFunction={newReconYearChangeHandler}
                    />
                  </Grid>
                </Grid>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="button-primary"
                type="submit"
                style={{ marginRight: "10px" }}
              >
                Submit
              </button>
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={newReconFormModalClose}
              >
                Close
              </button>
            </Modal.Footer>
          </ValidatorForm>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="report-status-modal-title"
          centered
          show={reportStatusModalOpen}
          onHide={closeReportStatusModal}
          dialogClassName="modal-lg"
        >
          <Modal.Header closeButton className="modal-header">
            <Modal.Title id="report-status-modal-title">
              Report Status Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="responsive-table">
              <table className="custome-table">
                <thead>
                  <tr>
                    <th>Recon Type</th>
                    <th>Financial Year</th>
                    <th>Book From Tax Period</th>
                    <th>Book To Tax Period</th>
                    <th>GSTR From Tax Period</th>
                    <th>GSTR To Tax Period</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {reportStatusData.length > 0 ? (
                    reportStatusData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.recon_type || "N/A"}</td>
                        <td>{item.financial_year || "N/A"}</td>
                        <td>{item.books_from_tax_period || "N/A"}</td>
                        <td>{item.books_to_tax_period || "N/A"}</td>
                        <td>{item.gstr_from_tax_period || "N/A"}</td>
                        <td>{item.gstr_to_tax_period || "N/A"}</td>
                        <td>{item.recon_status || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="button-outlined-primary"
              onClick={() => handleReportStatusRefresh(currentReconId)}
              style={{ marginRight: "10px" }}
            >
              Refresh
            </button>
            <button
              type="button"
              className="button-outlined-secondary"
              onClick={closeReportStatusModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <style>
          {`
            @keyframes pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.5; }
            }
            @media (min-width: 992px) {
              .modal-lg, .modal-xl {
                max-width: 80% !important;
              }
            }
          `}
        </style>

        <ModernNewsletterPopup />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>

      <BoxWrapper
        boxTitle="GSTR-9 Reconciliation"
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={refreshUploadHistoryTable}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>Fiscal Year</th>
                <th>Period</th>
                <th>Created date</th>
                <th>Status</th>
                <th>Report</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{historyTableBody()}</tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}